import { atomWithStorage } from 'jotai/utils';
import { darkMono } from '@/shared/visualTheme';
export const visualStyleAtom = atomWithStorage('visual_style', darkMono);
